export default __webpack_public_path__ + "static/needlefile-d9382422c1e2d679006205ca88b84a68.png";